<template>
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons/24px/Card">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9473 2.77632C15.8238 2.52933 15.5235 2.42922 15.2765 2.55271C15.0295 2.67621 14.9294 2.97654 15.0529 3.22353L16.6911 6.49993H8.30911L9.94731 3.22353C10.0708 2.97654 9.97069 2.67621 9.7237 2.55271C9.47671 2.42922 9.17637 2.52933 9.05288 2.77632L7.26403 6.35403C7.24042 6.40125 7.22498 6.45042 7.21718 6.49993H6.9616C4.83167 6.49993 3.19556 8.38638 3.49677 10.4949L4.51698 17.6363C4.83368 19.8532 6.73232 21.4999 8.97175 21.4999H16.0334C18.2728 21.4999 20.1715 19.8532 20.4882 17.6363L21.5084 10.4949C21.8096 8.38638 20.1735 6.49993 18.0435 6.49993H17.783C17.7752 6.45042 17.7598 6.40125 17.7362 6.35403L15.9473 2.77632ZM6.9616 7.49993C5.44022 7.49993 4.27157 8.84739 4.48672 10.3535L5.50692 17.4949C5.75325 19.2192 7.22997 20.4999 8.97175 20.4999H16.0334C17.7752 20.4999 19.2519 19.2192 19.4982 17.4949L20.5184 10.3535C20.7336 8.8474 19.5649 7.49993 18.0435 7.49993H6.9616Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
